import type { Router } from 'vue-router'
import { useChatStore } from '@/stores/modules/chat'
import sensors from '@/utils/sa-sdk-javascript'
import { extractChatDataFromQuery } from '@/utils/tools'
import { setTokenCache } from '@/storage/user'

export function createRouterGuards(router: Router) {
  const chatStore = useChatStore()

  // 导航守卫
  router.beforeEach(async (to, from, next) => {
    const chatData = extractChatDataFromQuery(to.query)

    // 从小程序带出来的token
    if (to.query.token) {
      setTokenCache(to.query.token)
    }

    if (import.meta.env.VITE_APP_ENV === 'production') {
      sensors.quick('autoTrack') // 页面进入
    }

    if (to.name !== 'chat') {
      next()
    } else {
      if (chatStore.robot.chat_id) {
        next()
      } else if (!chatData.region_id || chatData.region_id == '0') {
        // 250314: 加多一步，先调接口尝试拿一下
        const apiReturnRegionId = await chatStore.queryUserLastDealRegion({
          third_user_id: chatData.third_user_id
        })
        const region_id = apiReturnRegionId || localStorage.getItem('region_id')

        if (region_id) {
          chatData.region_id = region_id
          await chatStore.createChat(chatData)
          const _query = to.query
          _query.region_id = region_id
          next({
            name: 'chat',
            query: _query
          })
        } else {
          // 缺少region_id则跳转到城市选择页面
          next({ name: 'citySelect', query: to.query })
        }
      } else {
        try {
          await chatStore.createChat(chatData)
          next()
        } catch (error) {
          // 处理错误，比如重定向到错误页面或显示错误消息
          console.error('Failed to get robot info:', error)
          // 可以选择性地调用 next(false) 来阻止导航，并显示错误页面
        }
      }
    }
  })
}
